var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleIllustrationSubscriptionPpu = function SvgSimpleIllustrationSubscriptionPpu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "simple-illustration__subscription-ppu_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__subscription-ppu_svg__st1{fill:none;stroke:#002140;stroke-linecap:round;stroke-linejoin:round}.simple-illustration__subscription-ppu_svg__st3{fill:#f25730}")), /*#__PURE__*/React.createElement("path", {
    d: "M37.428 53.06V60h-6.437v-7.12h-10.37l-5.587-18.897h-.04A19.678 19.678 0 0 1 14 27.787C14 16.898 22.827 8.07 33.716 8.07c10.889 0 19.717 8.828 19.717 19.717 0 2.055-.315 4.038-.897 5.902l-.091.162-5.363 19.03h-9.476",
    style: {
      fill: "#4ed7de"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.428 53.06V60h-6.437v-7.12h-10.37l-5.587-18.897h-.04A19.678 19.678 0 0 1 14 27.787C14 16.898 22.827 8.07 33.716 8.07c10.889 0 19.717 8.828 19.717 19.717 0 2.055-.315 4.038-.897 5.902l-.091.162-5.363 19.03h-9.476",
    className: "simple-illustration__subscription-ppu_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.218 33.895c-1.029-2.055-1.359-4.142-1.359-6.108 0-8.206 6.653-14.859 14.859-14.859s14.859 6.653 14.859 14.859c0 2.235-.386 4.117-1.27 6.018",
    style: {
      fill: "#fffaf0"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.218 33.895c-1.029-2.055-1.359-4.142-1.359-6.108 0-8.206 6.653-14.859 14.859-14.859s14.859 6.653 14.859 14.859c0 2.235-.386 4.117-1.27 6.018",
    className: "simple-illustration__subscription-ppu_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.716 30.506a2.72 2.72 0 1 0 0-5.438 2.72 2.72 0 0 0 0 5.438z",
    className: "simple-illustration__subscription-ppu_svg__st3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m29.886 18.975-2.158 1.246 4.393 7.608 2.158-1.246-4.393-7.608z",
    className: "simple-illustration__subscription-ppu_svg__st3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.262 33.895h26.999",
    className: "simple-illustration__subscription-ppu_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26 43h16",
    style: {
      fill: "none",
      stroke: "#002140",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
};
export default SvgSimpleIllustrationSubscriptionPpu;